import httpClient from '@/services/http/httpClient'

export const apiGetGagDashboard = ({ fromDate = null, toDate = null, page = 1, orderBy = null }) => {
  return httpClient.get('/dashboard/', {
    params: {
      page,
      from_date: fromDate,
      to_date: toDate,
      order_by: orderBy
    }
  })
    .then(data => data)
    .catch(error => Promise.reject(error))
}

export const apiGetGagDashboardDocument = ({ fromDate = null, toDate = null, page = 1, orderBy = null }) => {
  return httpClient.get('/dashboard/export', {
    responseType: 'arraybuffer',
    params: {
      page,
      from_date: fromDate,
      to_date: toDate,
      order_by: orderBy
    }
  })
    .then(data => data)
    .catch(error => Promise.reject(error))
}
